import { useTrackrsAttention } from '@/hooks/useTrackrsAttention';
import { AttentionMark } from '@/components/integration/attention/AttentionMark';

/**
 * The count on the Projekter nav item. Renders nothing for users who may not
 * manage connections, while the backend has the feature off, and when there is
 * nothing to do — the sidebar must not grow a "0".
 *
 * IDP-only by placement: it calls the .NET hooks, so the sidebar mounts it inside
 * `IdpNavSections` only (the Firebase path has no client provider).
 */
export function TrackrsAttentionNavBadge() {
  const { available, openCount } = useTrackrsAttention();
  if (!available || openCount <= 0) return null;
  return (
    <span
      data-testid="trackrs-attention-badge"
      title="Vi har brug for din hjælp her"
      aria-label={`${openCount} ting venter på jer i Trackrs-forbindelsen`}
      className="ml-auto inline-flex items-center gap-1 rounded-full bg-white/90 py-0.5 pl-0.5 pr-2 text-[11px] font-semibold text-amber-800 shadow-sm ring-1 ring-amber-200 dark:bg-dark-card dark:text-amber-300 dark:ring-amber-900/60"
    >
      <AttentionMark size="sm" />
      {openCount}
    </span>
  );
}
